import { customAlphabet } from "nanoid";

const defaultAlphabet =
	"1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

function playerID(): string {
	const nanoid = customAlphabet(defaultAlphabet, 16);
	return nanoid();
}

/**
 * Generate a unique party ID.
 * The ID is a random string of 5 uppercase letters. Simpler alphabet to simplify communicating.
 */
function partyID(): string {
	const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const nanoid = customAlphabet(alphabet, 5);
	return nanoid();
}

function roundID(): string {
	const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
	const nanoid = customAlphabet(alphabet, 8);
	return nanoid();
}

function randomString(length = 16): string {
	const nanoid = customAlphabet(defaultAlphabet, length);
	return nanoid();
}

function emitCode(length: number): string {
	const alphabet = "1234567890";
	const nanoid = customAlphabet(alphabet, length);
	return nanoid();
}

export { playerID, partyID, roundID, randomString, emitCode };

export default randomString;
